import { render, staticRenderFns } from "./TheFavoritesPage.vue?vue&type=template&id=f0ef3092&"
import script from "./TheFavoritesPage.vue?vue&type=script&lang=js&"
export * from "./TheFavoritesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports